<template>
  <v-card class="mb-4 hvh-card--rounded hvh-analysis-segments">
    <CardTitle :title="computedTitle" :class="{ 'pb-0': !isCollapsed }" v-model="isCollapsed" />
    <div class="hvh-categories" v-show="!isCollapsed">
      <v-card-text class="pt-0">
        <div class="hvh-relative">
          <InputCheckbox :value="allSelected" class="mt-0" :color="selectAllColor" text="Select all" @input="onSelectAllChange()" />
        </div>
        <InputCheckbox v-model="item.checked" @input="emitChange()" class="mt-1 hvh-analysis-segments__checkbox--lvl2" :color="item.color" :text="item.label" :title="item.tooltip || ''" :key="item.label + ind" v-for="(item, ind) in items" />
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { propToBool } from '../../libraries/common';
import CardTitle from '../common/cardTitle/HvhCardTitle.vue';
import InputCheckbox from '../common/form/inputCheckbox/HvhInputCheckbox';

export default {
  components: {
    CardTitle,
    InputCheckbox,
  },
  props: ['title', 'items', 'showAllCount', 'startCollapsed'],
  data(self) {
    return {
      showAllItems: false,
      filterText: null,
      isCollapsed: propToBool(self.startCollapsed) || false,
    };
  },
  methods: {
    emitChange() {
      this.$emit('change', this.items);
    },
    onSelectAllChange() {
      const shouldSelectAll = this.selected.length < this.items.length;
      this.items.forEach(f => this.$set(f, 'checked', shouldSelectAll));
      this.emitChange();
    },
  },
  computed: {
    selectAllColor() {
      return this.selected.length === this.items.length ? '#11697d' : 'grey';
    },
    selected() {
      return this.items.filter(f => f.checked);
    },
    allSelected() {
      return this.selected.length > 0;
    },
    computedTitle() {
      var allChecked = this.items.filter(f => f.checked).length === this.items.length;
      return this.title + (allChecked ? '' : ' *');
    }
  },
};
</script>

<style lang="scss">
.hvh-categories {
  overflow-x: hidden;
  overflow-y: auto;
}

.hvh-analysis-segments {
  .v-input {
    display: block;
  }

  .v-label {
    color: $color-text-default;
    font-size: rem(14px);
  }
}

.hvh-analysis-segments__checkbox--lvl2 {
  padding-left: rem(12px);
}

.hvh-edit-position {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
